import React, { createContext, useCallback, useContext, useState } from 'react';
import { useAddRoomAttachmentMutation } from '../../../../api/addRoomAttachment';
import { modalNames } from '../../../../shared/configs/modal';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { fieldNames } from '../../constants';
import { useInvalidateRoomAttachments } from '../../../../api/roomAttachments';

const modalName = modalNames.attachmentsForm;

export const SubmitContext = createContext();
const SubmitStateContext = createContext();
const SubmitSetStateContext = createContext();

export const useSubmitState = () => useContext(SubmitStateContext);
export const useSubmitSetState = () => useContext(SubmitSetStateContext);

export const SubmitProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [submitState, setSubmitState] = useState(null);

  const { mutateAsync: addAttachment } = useAddRoomAttachmentMutation();

  const invalidateAttachments = useInvalidateRoomAttachments();

  const { getProps, closeAndKeepProps } = useModalMethods();

  const onSubmit = useCallback(
    async (values) => {
      const { room, record } = getProps(modalName) ?? {};

      const addressId = room?.id;

      const acceptanceClientId = record?.id;

      setLoading(true);

      const {
        [fieldNames.files]: files,
        [fieldNames.clientId]: clientId,
        [fieldNames.typeId]: typeId,
        ...rest
      } = values;

      const promises = await Promise.allSettled(
        files.map((file) => {
          return addAttachment({
            addressId,
            typeId,
            acceptanceClientId,
            data: rest,
            file,
            showErrorMessage: true,
          });
        })
      );

      if (promises.every((result) => result === 'Error')) {
        setSubmitState({
          status: 'error',
          source: 'attachment',
          message: (
            <>
              Не удалось добавить ни одного файла. <br /> Попробуйте отправить
              еще раз.
              <br /> Если это не первая попытка, обратитесь в техподддержку.
            </>
          ),
        });
      } else {
        invalidateAttachments({ addressId });
        closeAndKeepProps(modalName);
      }
    },
    [addAttachment, closeAndKeepProps, getProps, invalidateAttachments]
  );

  return (
    <SubmitContext.Provider value={{ onSubmit, loading }}>
      <SubmitStateContext.Provider value={submitState}>
        <SubmitSetStateContext.Provider value={setSubmitState}>
          {children}
        </SubmitSetStateContext.Provider>
      </SubmitStateContext.Provider>
    </SubmitContext.Provider>
  );
};
